export default "__VITE_ASSET__BHG2HXRZ__"